export default "__VITE_ASSET__2ddbdb8a__"